import { render, staticRenderFns } from "./BlackListedSubscribers.vue?vue&type=template&id=aab3e3de&scoped=true"
import script from "./BlackListedSubscribers.vue?vue&type=script&lang=js"
export * from "./BlackListedSubscribers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab3e3de",
  null
  
)

export default component.exports